module.exports = __webpack_public_path__ + "static/media/homeownerslaptop.32c669dc.png";